{
  "name": "gsplanning",
  "version": "1.5.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:UAT": "ng build --base-href / --configuration=uat",
    "build:PROD": "ng build --base-href / --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.3",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "^22.2.3",
    "@angular/language-service": "^22.2.3",
    "@angular/material": "22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@automapper/classes": "^8.7.6",
    "@automapper/core": "^8.7.6",
    "@js-temporal/polyfill": "^0.4.2",
    "angular-calendar": "^0.32.2",
    "bootstrap": "^5.2.2",
    "date-fns": "^4.4.0",
    "detect-browser": "^5.3.0",
    "jwt-decode": "^3.1.2",
    "konva": "^9.3.20",
    "lodash": "^4.17.21",
    "ngx-mat-timepicker": "^22.1.0",
    "reflect-metadata": "^0.1.13",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@types/jasmine": "~3.10.0",
    "@types/lodash": "^4.14.186",
    "@types/node": "^26.6.5",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "typescript": "~6.0.3"
  }
}